import { Link } from "react-router-dom";
import { categories } from "@/mocks/gossip";
import { getArticlesByCategory } from "@/utils/gossip";
import ArticleCard from "@/components/base/ArticleCard";
import Breadcrumb from "@/components/base/Breadcrumb";
import Seo from "@/components/feature/Seo";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "专题分类 - 看料吃瓜社",
    url: "https://kanliaochigua.example/topics",
    inLanguage: "zh-CN",
    description:
      "看料吃瓜社六条常驻内容线总览，覆盖娱乐风云、网红观察、影视综艺、音乐现场、电竞竞技与时尚潮流。",
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://kanliaochigua.example/" },
      { "@type": "ListItem", position: 2, name: "专题分类", item: "https://kanliaochigua.example/topics" },
    ],
  },
];

export default function Topics() {
  return (
    <>
      <Seo
        title="专题分类 | 六条常驻内容线总览 - 看料吃瓜社"
        description="看料吃瓜社专题分类页，按娱乐风云、网红观察、影视综艺、音乐现场、电竞竞技、时尚潮流六条内容线归档瓜料，方便顺着线索往前翻。"
        keywords="看料吃瓜分类,看料吃瓜专题,娱乐风云,影视综艺,音乐现场,电竞竞技,时尚潮流"
        path="/topics"
        jsonLd={jsonLd}
      />

      <div className="w-full bg-background-100 border-b border-background-200">
        <div className="w-full px-4 md:px-6 py-8 md:py-12">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "专题分类" }]} />
          <h1 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            专题分类：六条常驻内容线
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
            与其在热榜里来回翻，不如按内容线顺着看。每条线都保留了完整的归档顺序，方便你从最早的一条读到最新的一条。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-6 py-10 md:py-14 space-y-14 md:space-y-20">
        {categories.map((category, index) => {
          const list = getArticlesByCategory(category.id);
          const isReversed = index % 2 === 1;
          return (
            <section key={category.id} aria-labelledby={`topic-${category.id}`}>
              <div
                className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-start ${
                  isReversed ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div className="lg:col-span-4">
                  <div className="lg:sticky lg:top-28">
                    <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center text-2xl mb-4">
                      <i className={category.icon}></i>
                    </span>
                    <h2
                      id={`topic-${category.id}`}
                      className="font-heading text-xl md:text-2xl font-bold text-foreground-950"
                    >
                      {category.name}
                    </h2>
                    <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{category.desc}</p>
                    <div className="mt-4 flex items-center gap-3 text-xs font-label text-foreground-500">
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-folder-3-line text-secondary-600"></i>
                        共 {category.count} 条瓜料
                      </span>
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-database-2-line text-secondary-600"></i>
                        当前展示 {list.length} 条
                      </span>
                    </div>
                    <Link
                      to={`/hot?category=${category.id}`}
                      className="mt-5 inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-label font-medium rounded-md bg-secondary-500 text-background-50 hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      进入该内容线
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>

                <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
                  {list.slice(0, 3).map((item) => (
                    <ArticleCard key={item.id} article={item} />
                  ))}
                  {list.length === 0 && (
                    <p className="text-sm text-foreground-500">该内容线暂无收录内容，敬请期待。</p>
                  )}
                </div>
              </div>
            </section>
          );
        })}
      </div>
    </>
  );
}